import ListContentLayout from 'layout/ListContentLayout'
import { FC, useEffect, useState } from 'react'
import ControlActionPlanModal from 'components/shared/Modals/ControlActionPlanModal'
import { MDataTable } from 'components/shared/MDataTable'
import useSelectAll from 'hooks/useSelectAll'
import useFetchPage2 from 'hooks/useFetchPage2'
import MarketUpdatesViewModal from 'features/automation/components/market-updates/MarketUpdatesViewModal'
import { queryClient } from 'lib/react-query'
import BuilkActions from '../../components/action-plan/BuilkActions'
import TableColumns from '../../components/action-plan/TableColumns'
import { TActionPlanList } from '../../types'

type TControlType = 'Pause' | 'Stop' | 'Completed' | 'Running'
export type TControlAPModal = {
 type: TControlType | null
 show: boolean
 id: any
}

const RealEstateNewsList: FC = () => {
 const [searchKey, setSearchKey] = useState('')
 const [showModal, setShowModal] = useState<TControlAPModal>({
  type: null,
  show: false,
  id: null,
 })
 const [showViewModal, setShowViewModal] = useState<null | string>(null)
 const {
  isLoading,
  hasMore,
  fetchMore,
  refetch,
  flatData,
  isRefetching,
  total,
 } = useFetchPage2<TActionPlanList>('newsletters', {
  params: `type=Real-Estate-News-Letter${
   searchKey ? `&search=${searchKey}` : ''
  }`,
 })

 const {
  selectedKeys,
  onSelectRow,
  rowSelectionState,
  selectedRows,
  selectAll,
  unSelected,
  setSelectedRow,
 } = useSelectAll(JSON.stringify({ search: searchKey }))

 useEffect(() => {
  if (selectAll && flatData && flatData?.length > 0) {
   const newunSelected = new Set(unSelected)
   const result = flatData?.filter((obj: any) => !newunSelected.has(obj.id))
   setSelectedRow(result as any)
  }
 }, [flatData, selectAll, unSelected])

 return (
  <>
   <ListContentLayout
    title="Real Estate Newsletter"
    actions={
     <BuilkActions
      actionRefresh={refetch}
      selectedRows={selectedRows}
      selectAll={selectAll}
      unSelected={unSelected}
      filterInfo={JSON.stringify({ search: searchKey })}
      mode="Real-Estate-News-Letter"
     />
    }
   >
    <MDataTable
     totalData={total || 1000}
     search={{
      placeholder: 'Enter the name of Real Estate Newsletter',
      onSearch: setSearchKey,
      show: true,
     }}
     onSelectRow={onSelectRow}
     rowSelectionState={{
      ...rowSelectionState,
     }}
     loading={isLoading}
     isFetching={isRefetching}
     hasMore={hasMore}
     fetchMore={() => fetchMore()}
     data={flatData}
     columns={TableColumns({
      selectedKeys,
      selectAll,
      unSelected,
      handleClickView: (id?: any) => setShowViewModal(id),
      handleControlAP: (type: TControlType, id?: any) => {
       queryClient.removeQueries({
        queryKey: `assignlist-${id}-${type}-`,
        exact: true,
       })
       setShowModal({ id, type, show: true })
      },
      mode: 'real-estate-news',
      refetch,
     })}
    />
    {showModal?.show && (
     <ControlActionPlanModal
      ctrlAP={showModal}
      onCancel={() => setShowModal({ show: false, type: null, id: null })}
      refetch={refetch}
      from="real-estate-news"
     />
    )}
   </ListContentLayout>
   {showViewModal !== null && (
    <MarketUpdatesViewModal
     visible={showViewModal !== null}
     onToggle={() => setShowViewModal(null)}
     id={Number(showViewModal)}
     type="Real-Estate-News-Letter"
    />
   )}
  </>
 )
}

export default RealEstateNewsList
